function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.526 19.167L7.5 10.833H4.167V7.5H7.5V5.417C7.5 2.324 9.415.833 12.174.833c1.322 0 2.458.099 2.789.143v3.232h-1.914c-1.5 0-1.79.714-1.79 1.76V7.5h4.366l-1.667 3.333h-2.7v8.334H7.526z",
  fill: "#008CD1"
});

function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik03LjUyNiAxOS4xNjdMNy41IDEwLjgzM0g0LjE2N1Y3LjVINy41VjUuNDE3QzcuNSAyLjMyNCA5LjQxNS44MzMgMTIuMTc0LjgzM2MxLjMyMiAwIDIuNDU4LjA5OSAyLjc4OS4xNDN2My4yMzJoLTEuOTE0Yy0xLjUgMC0xLjc5LjcxNC0xLjc5IDEuNzZWNy41aDQuMzY2bC0xLjY2NyAzLjMzM2gtMi43djguMzM0SDcuNTI2eiIKICAgICAgICBmaWxsPSIjMDA4Q0QxIiAvPjwvc3ZnPg==";
export { SvgFacebookLogo as ReactComponent };